module.exports = __webpack_public_path__ + "static/media/IMG_8893.51d34891.JPG";